import { Button, Modal } from "antd";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { SetupAction } from "../../actions";
import { AUTO_EMAIL_SETUP } from "../../config/media";
import { SuccessEmailWrapper } from "./style";


const SetupEmailSuccess = (props) => {
    const { emailSetup } = props;
    const [isVisible, setIsVisible] = useState(emailSetup);

    useEffect(() => {
        setIsVisible(emailSetup);
    }, [emailSetup])

    const handleOkay = () => {
        props.updateEmailSetup({ EMAIL_SETUP: { success: true, show: false } })
    }

    const renderContent = () => {
        return (
            <div className='container'>
                <div className='image-container'><img src={AUTO_EMAIL_SETUP} alt="auto-emails-setup-complete" /></div>
                <div className="title">Email setup complete!</div>
                <div className='margin-05'>To go live, please check that you've connected a domain and paid any pending cloud hosting bills.</div>
                <div className="setup-btn-container">
                    <Button
                        type="primary"
                        onClick={handleOkay}
                    >
                        Okay
                    </Button>
                </div>
            </div>
        )
    }

    return (
        <>
            <Modal
                visible={isVisible.success && isVisible.show}
                footer={null}
                width={"33rem"}
                onCancel={handleOkay}
            >
                <SuccessEmailWrapper>
                    {renderContent()}
                </SuccessEmailWrapper>
            </Modal>
        </>
    )
}

const mapStateToProps = (state) => ({
    emailSetup: state.setup.EMAIL_SETUP
})

const mapDispatchToProps = (dispatch) => ({
    updateEmailSetup: bindActionCreators(SetupAction.updateEmailSetup, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(SetupEmailSuccess);
